import axios from '../../utils/axios';

export default function deleteLGBill(adminId, billId, data) {
    return (
        axios.post(`/admin/${adminId}/lGBill/${billId}/delete`,  data)
    )
}
